import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import TemplateForm from '../../components/Templates/TemplateForm';
import templateService from '../../services/templateService';

const TemplateEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [template, setTemplate] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadTemplate();
  }, [id]);

  const loadTemplate = async () => {
    try {
      const data = await templateService.getTemplateById(id);
      setTemplate(data.template);
    } catch (error) {
      console.error('Error loading template:', error);
      toast.error('Failed to load template');
      navigate('/app/templates');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (templateData) => {
    try {
      await templateService.updateTemplate(id, templateData);
      toast.success('Template updated successfully');
      navigate('/app/templates');
    } catch (error) {
      console.error('Error updating template:', error);
      toast.error(error.response?.data?.error || 'Failed to update template');
    }
  };

  const handleCancel = () => {
    navigate('/app/templates');
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-gray-500">Loading template...</div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900">Edit Template</h1>
        <p className="text-gray-600 mt-1">Update template information</p>
      </div>

      <TemplateForm template={template} onSubmit={handleSubmit} onCancel={handleCancel} />
    </div>
  );
};

export default TemplateEdit;

